import { useMemo } from "react"

import cls from "classnames"
import { useSelector } from "react-redux"
import { useLocation } from "react-router-dom"

import { getJourneyState } from "../../../../Utils/onboarding/getJourneyState"
import {
  CHOICE_FLOWS,
  hasOnboardingProgress,
  resolveProductChoice
} from "../../../../Utils/onboarding/productChoice"
import { getApplicableSteps } from "../../../../Utils/onboarding/stepSequence"
import { BA_STEPS } from "../../../GettingStartedPage/utils/businessSteps"

// One dot per applicable step, filled up to the one on screen (OB-3-26, OB-3-27). Both flows
// apply the same skip rules as their checklist and rail, so a Recover-only setup shows fewer dots.
const OnboardingDots = () => {
  const { pathname } = useLocation()
  const userInfo = useSelector((state) => state.auth?.userInfo)
  const userState = useSelector((state) => state.user)

  const isNewBusiness = pathname?.includes("/create-account")

  const steps = useMemo(() => {
    if (isNewBusiness) {
      const journey = getJourneyState({ userInfo, userState, pathname })
      const flow = CHOICE_FLOWS.BUSINESS
      const choice = resolveProductChoice({
        flow,
        hasProgress: hasOnboardingProgress({ flow, nextCreateAccountStep: journey.currentStep })
      })
      const journeyIds = journey.steps.map((s) => s.step)

      return getApplicableSteps({ choice }).filter(
        (s) => BA_STEPS[s.step] === undefined || journeyIds.includes(BA_STEPS[s.step])
      )
    }

    const flow = CHOICE_FLOWS.ONBOARDING

    return getApplicableSteps({
      choice: resolveProductChoice({ flow, hasProgress: hasOnboardingProgress({ flow, userInfo }) })
    })
  }, [isNewBusiness, pathname, userInfo, userState])

  const activeIndex = useMemo(() => {
    const currentKey = pathname.split("/")[2]

    return Math.max(
      0,
      steps.findIndex((s) => s.key === currentKey)
    )
  }, [pathname, steps])

  return (
    <div className="ob-dots" aria-label="Progress">
      {steps.map((s, i) => (
        <span key={s.key} className={cls("ob-dot", { "is-active": i <= activeIndex })} />
      ))}
    </div>
  )
}

export default OnboardingDots
